import { useEffect } from 'react';
import { useActivityContext } from '../context/activity-store';
import { getCancelPaymentAnalyticsEvent } from '../const/analytics/cancel-payment';
import { getSelectPayAnalyticsEvent } from '../const/analytics/select-pay';
import { getSpendingTrendsAnalyticsEvent } from '../const/analytics/spending-trends';
var analyticsFnMap = {
    cancelPayment: getCancelPaymentAnalyticsEvent,
    selectPay: getSelectPayAnalyticsEvent,
    spendingTrends: getSpendingTrendsAnalyticsEvent
};
var useTriggerAnalyticsEvent = function (featureEvent, promotions, shouldTrigger) {
    if (shouldTrigger === void 0) { shouldTrigger = true; }
    var triggerAnalyticsEvent = useActivityContext().triggerAnalyticsEvent;
    useEffect(function () {
        var _a = featureEvent.split('.'), feature = _a[0], eventName = _a[1];
        if (!shouldTrigger)
            return;
        if (feature === 'cancelPayment') {
            triggerAnalyticsEvent(analyticsFnMap[feature](eventName));
        }
        else if (feature === 'selectPay') {
            triggerAnalyticsEvent(analyticsFnMap[feature](eventName));
        }
        else if (feature === 'spendingTrends') {
            triggerAnalyticsEvent(analyticsFnMap[feature](eventName));
        }
    }, [featureEvent, promotions, shouldTrigger, triggerAnalyticsEvent]);
};
export default useTriggerAnalyticsEvent;
//# sourceMappingURL=use-trigger-analytics-event.js.map